<template>
  <a href="#" class="block block-link-shadow block-rounded block-bordered" :class="{'package-type--selected': selected, 'disabled': !provider}" @click.prevent="onClick">
    <div class="block-content block-content-full">
      <div class="py-5 text-center">
        <div class="mb-15">
          <i :class="[`fa fa-${icon} fa-3x text-muted`, {'text-whites': selected}]"></i>
        </div>
        <div class="font-size-sm font-w600 text-uppercase text-muted" :class="{'text-whites': selected}">
          <img v-if="provider" :src="require(`./shipping-provider-icons/${provider}.png`)" class="shipping-provider-icon">
          <slot />
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    icon: String,
    selected: Boolean,
    provider: String
  },
  methods: {
    onClick (e) {
      if (!this.provider) {
        this.$swal('', 'Dit pakkettype is niet beschikbaar voor deze bestelling.', 'warning')
        return
      }

      this.$emit('click', e)
    }
  }
}
</script>

<style scoped>
.shipping-provider-icon {
  height: 16px;
  width: 16px;
  transform: translate(0, -1px);
}

.package-type--selected {
  box-shadow: 0px 0px 0px 3px #6eab4d !important;
}

.package-type--selected:before {
  font: normal normal normal 14px/1 FontAwesome;
  content: "\f00c";
  color: #fff;
  z-index: 99;
  padding: 0.5rem;
  position: absolute;
  top: -15px;
  right: -15px;
  background: #6eab4d;
  border-radius: 100%;
  border: 2px solid #fff;
}
</style>



// WEBPACK FOOTER //
// PackageType.vue?845694ba